module.exports = __webpack_public_path__ + "static/Woman-e10df0b1c04d2e7963572d0ace29a74d.jpg";